import { Draggable } from 'sharedFeatures/sharedServices/drag-drop-manager.service';
import {BaseEvent} from "sharedFeatures/directives/events/base-event";

export class DraggEvent implements BaseEvent<MouseEvent>{


    constructor(public event: MouseEvent, public directive: Draggable) {


    }
    
}